import { render, staticRenderFns } from "./DesktopNavigationNode.vue?vue&type=template&id=33a847a2&"
import script from "./DesktopNavigationNode.vue?vue&type=script&lang=js&"
export * from "./DesktopNavigationNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/philippneumann/Documents/frontendstudios/Gonser/GonserDT-Theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33a847a2')) {
      api.createRecord('33a847a2', component.options)
    } else {
      api.reload('33a847a2', component.options)
    }
    module.hot.accept("./DesktopNavigationNode.vue?vue&type=template&id=33a847a2&", function () {
      api.rerender('33a847a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/pageDesign/DesktopNavigationNode.vue"
export default component.exports